import React from "react";
import { motion } from "framer-motion";

/**
 * Reusable elegant page header for interior pages.
 * @param {string} overline - small gold label above title
 * @param {string} title - large heading (supports linebreaks via \n)
 * @param {string} subtitle - description
 * @param {string} image - background image URL
 */
export default function PageHeader({ overline, title, subtitle, image }) {
  return (
    <section className="relative pt-40 pb-24 md:pt-48 md:pb-32 overflow-hidden" data-testid="page-header">
      <div className="absolute inset-0">
        <img src={image} alt="" className="w-full h-full object-cover" loading="eager" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A2342]/95 via-[#0A2342]/70 to-[#0A2342]/95" />
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 text-white">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <div className="flex items-center gap-3 mb-5">
            <span className="w-10 h-px bg-[#C9A227]" />
            <span className="overline text-[#C9A227]">{overline}</span>
          </div>
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[0.98] max-w-4xl whitespace-pre-line">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-6 text-white/80 text-base md:text-lg max-w-2xl leading-relaxed font-light">
              {subtitle}
            </p>
          )}
        </motion.div>
      </div>
    </section>
  );
}
